/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M8.66 4.86h2.68l-.23 6.75H8.88l-.22-6.75zm-.09 9.02c0-.81.53-1.28 1.43-1.28.9 0 1.43.47 1.43 1.28 0 .8-.53 1.26-1.43 1.26-.9 0-1.43-.46-1.43-1.26z",
  className: "foreground"
}), React.createElement("path", {
  d: "M10 20a10 10 0 110-20 10 10 0 010 20zm-1.43-6.12c0 .8.53 1.26 1.43 1.26.9 0 1.43-.46 1.43-1.26 0-.81-.53-1.28-1.43-1.28-.9 0-1.43.47-1.43 1.28zm.09-9.02l.22 6.75h2.23l.23-6.75H8.66z"
}));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "Failure";
Svg.element = element;
export default Svg;
